import config from 'src/config'
import { isLinkExternal } from 'src/utils/misc'
import nb from 'src/json/locales/nb.json'
import sv from 'src/json/locales/sv.json'

const localeConfig: { [key: string]: { [id: string]: string } } = {
  nb: nb[config.namespace],
  sv: sv[config.namespace],
}

const { locales } = config
export const prefixes = Object.keys(config.locales)
  .filter((locale) => config.locales[locale].path !== '')
  .map((locale) => config.locales[locale].path.replace('/', ''))

export const getMessagesByLocale = (locale: string) => localeConfig[locale]

export const getIntlUrl = (url = '', locale = '') => {
  let localUrl = url || ''
  if (isLinkExternal(localUrl)) {
    return localUrl
  }
  localUrl = localUrl.startsWith('/') ? localUrl.substr(1) : localUrl
  if (!locales.hasOwnProperty(locale)) {
    return `/${localUrl}`
  }
  const prefix = locales[locale] ? locales[locale].path : ''
  // Handle prefixed urls with incorrect prefix for current locale
  const urlParts = localUrl.split('/')
  if (prefixes.includes(urlParts[0])) {
    localUrl = urlParts.slice(1, urlParts.length).join('/')
  }
  return `${prefix}${localUrl ? '/' : ''}${localUrl}`
}

export const getDefaultLocale = () => {
  const defaultLocale = Object.keys(locales).filter(
    (locale) => locales[locale].default
  )
  return defaultLocale ? defaultLocale[0] : 'sv' || 'sv'
}

export const getLocaleByPath = (pathname = '') => {
  const pagePath = pathname.split('/').filter((p) => !!p)
  if (prefixes.includes(pagePath[0])) {
    return pagePath[0]
  }
  // Return falsy so we can check for success
  return ''
}

export const getLocaleByHost = (hostname = '') => {
  if (hostname) {
    return (
      Object.keys(locales).filter((locale) => {
        const tlds = locales[locale].tlds
        for (const localTld of tlds) {
          if (hostname.slice(-localTld.length) === localTld) {
            return true
          }
        }
        return false
      })[0] || ''
    )
  }
  return ''
}

export const getBrowserLocale = () => {
  if (navigator) {
    let locale
    if (navigator.languages && navigator.languages.length) {
      locale = navigator.languages[0]
    } else {
      locale =
        // @ts-ignore
        navigator.userLanguage ||
        navigator.language ||
        // @ts-ignore
        navigator.browserLanguage ||
        ''
    }
    locale = locale.split('-')[0] || getDefaultLocale()
    if (prefixes.includes(locale)) {
      return locale
    }
  }
  return ''
}
